import React, { Component, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Popconfirm,
} from 'antd';
import Success from '@Images/admin/success.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import { SettingOutlined, DeleteOutlined, LoadingOutlined } from '@ant-design/icons';

/**
 *
 */
const ShopifyConnectionList = ({
  getShopifyConnectionsLoading, history, shopifyConnections, updateShopifyConnectionLoading, updateShopifyConnection, getShopifyConnections, user, deleteShopifyConnection,
}) => (
  <div className="shopify-list-wrapper">
    {
      !getShopifyConnectionsLoading && shopifyConnections ? (
        <React.Fragment>
          {shopifyConnections.map((item) => (
            <React.Fragment key={item?.iz_id}>
              <div className={`shopify-card ${(item?.is_connected === false && shopifyConnections?.find((rec) => rec.is_connected)) ? 'shopify-card-inactive' : ''}`}>
                <div className="shopify-card-spacing">
                  <div className="shopify-card-header">
                    <p>
                      {item?.shop_name}
                    </p>
                    {item?.is_connected && <img src={Success} alt="" className="shopify-card-header__img" />}
                  </div>
                  <H3Text text={`${item?.locations?.length || '0'} Location(s)`} className="shopify-card-link" />
                  <div className="shopify-card-link" />
                  <div className="shopify-card-footer">
                    <div className="flex text-gray">
                      {item?.is_connected ? (
                        <div style={{
                          display: 'flex',
                          'justify-content': 'space-between',
                          width: '100%',
                          'align-items': 'baseline',
                        }}
                        >
                          <Popconfirm
                            placement="topRight"
                            title="Are you sure you want to delete this connection?"
                            onConfirm={() => {
                              const payload = {
                                org_id: user?.tenant_info?.org_id,
                                shop_name: item?.shop_name,
                              };
                              deleteShopifyConnection(payload, () => {
                                history.push('/admin/integration/');
                              });
                            }}
                            okText="Yes"
                            cancelText="No"
                          >
                            <div className="delete-button">
                              {' '}
                              <DeleteOutlined />
                              {' '}
                            </div>
                          </Popconfirm>
                          <div
                            className="shopify-card-footer__link"
                            onClick={() => {
                              history.push('/admin/integration/shopify/setup');
                            }}
                          >
                            <SettingOutlined />
                            &nbsp;
                            Edit Configuration
                          </div>
                        </div>
                      ) : (
                        <div />
                      )}
                      {!item?.is_connected && (
                        <Popconfirm
                          placement="topRight"
                          title="Switching to a different organisation can impact for Vendor Payables data on Shopify Books. Are your sure you want continue?"
                          onConfirm={() => updateShopifyConnection(
                            {
                              iz_id: item?.iz_id,
                              is_connected: true,
                            },
                            () => getShopifyConnections(user?.tenant_info?.org_id),
                          )}
                          okText="Activate"
                          okButtonProps={{
                            loading: updateShopifyConnectionLoading,
                          }}
                          cancelText="Cancel"
                        >
                          <H3Button
                            text="Set as Default"
                            buttonType={defaultButtonTypes.BLUE_ROUNDED}
                            customClass="shopify__activate-btn"
                            isLoading={updateShopifyConnectionLoading}
                            disable={updateShopifyConnectionLoading}
                          />
                        </Popconfirm>
                      )}
                    </div>
                  </div>

                </div>
              </div>
            </React.Fragment>
          ))}
        </React.Fragment>
      ) : (
        <div
          className="shopify-list-wrapper"
        >
          <div
            className="loading-shopify__card  "
          >
            <div className="shopify-card-spacing">

              <div className="shopify-card-header ">

                <div className="loadingBlock loading-shopify-header__text" />
                <div className="loadingBlock loading-shopify-header__image"> </div>
              </div>

              <div className="loadingBlock loading-shopify-card__link"> </div>
              <div className="shopify-card-footer">
                <div
                  className="flex "
                >

                  <p className="loadingBlock loading-shopify-card__footer" />
                </div>
              </div>
            </div>
          </div>

        </div>
      )

    }

  </div>
);

const mapStateToProps = ({ UserReducers, ShopifyIntegrationReducers }) => ({
  user: UserReducers.user,
  shopifyConnections: ShopifyIntegrationReducers.shopifyConnections,
  updateShopifyConnectionLoading: ShopifyIntegrationReducers.updateShopifyConnectionLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updateShopifyConnection: (payload, callback) => dispatch(ShopifyIntegrationActions.updateShopifyConnection(payload, callback)),
  getShopifyConnections: (orgId, callback) => dispatch(ShopifyIntegrationActions.getShopifyConnections(orgId, callback)),
  deleteShopifyConnection: (payload, callback) => dispatch(ShopifyIntegrationActions.deleteShopifyConnection(payload, callback)),
});
ShopifyConnectionList.propTypes = {
  user: PropTypes.any,
  shopifyConnections: PropTypes.any,
  getShopifyConnectionsLoading: PropTypes.bool,
  updateShopifyConnectionLoading: PropTypes.bool,
  history: PropTypes.any,
  updateShopifyConnection: PropTypes.bool,
  getShopifyConnections: PropTypes.func,
  deleteShopifyConnection: PropTypes.func,
  deleteShopifyConnectionLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShopifyConnectionList));
